<template>
	<div class="pub">
		<el-drawer
			title="我是标题"
			:visible.sync="drawer"
			:with-header="false"
			direction="ltr"
			:modal="false"
			ref="changeHeight"
			:style="'background-color: #143166'"
		>
			<div style="margin: 20px;">
				<el-input v-model="search" placeholder="请输入搜索内容">
					<el-button slot="append" icon="el-icon-search" @click="queryArc()">搜索</el-button>
				</el-input>
			</div>
			<ul v-for="(item, index) in column" :key="index" :index="String(index)" @click="changColumn(item)">
				<li>
					<a href>{{ item }}</a>
				</li>
			</ul>
		</el-drawer>
		<div class="choose-city" v-if="close">
			<div class="icon-close">
				<i class="el-icon-circle-close" @click="closeIcon()"></i>
			</div>
			<div class="choose-city-content">
				<div class="choose-city-content1">
					<div class="choose-city-boxs">
						<div class="choose-city-box">
							<p class="choose-city-txt1">当前位置</p>
							<div class="showcity" style="clear:none">
								<a href>{{ city }}</a>
							</div>
						</div>
						<div class="choose-city-box">
							<p class="choose-city-txt1">地方站点</p>
							<div class="showcity1" v-for="item in region" :key="item" @click="passCity(item)">
								<a href>{{ item }}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="check-detection" v-if="check">
			<p>
				检测到您的地区为：{{ checkCity }}，是否要切换到{{ checkCity }}站
				<button class="switch-button" @click="chgeCity()">切换</button>
			</p>
			<div class="close-icon">
				<i class="el-icon-circle-close" @click="closeCheck()"></i>
			</div>
		</div>
		<div
			class="nav"
			:style="
				bodyWidth > 768 ? 'background-image: url(' + topbottom.topBackGroundImage + ')' : 'background-image: url(' + topbottom.phoneTop + ')'
			"
		>
			<div class="tou">
				<div class="select-city" ref="select">
					<el-popover placement="bottom-end" width="350" trigger="hover" close-delay:100>
						<el-tabs v-model="activeName">
							<el-tab-pane label="全部城市" name="first">
								<div style="width:100%;">
									<div
										class="reg"
										style="float:left;width:25%;height:30px"
										v-for="(i, index) in region"
										:key="index"
										@click="passCity(i)"
									>
										<a href style=" text-decoration:none;color:black">{{ i }}</a>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="ABCDEFGH" name="second">
								<div style="width:100%;">
									<div
										class="reg"
										style="float:left;width:25%;height:30px"
										v-for="(i, index) in abcdefgh"
										:key="index"
										@click="passCity(i)"
									>
										<a href style=" text-decoration:none;color:black">{{ i }}</a>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="IJKLMNOP" name="third">
								<div style="width:100%;">
									<div
										class="reg"
										style="float:left;width:25%;height:30px"
										v-for="(i, index) in ijklmnop"
										:key="index"
										@click="passCity(i)"
									>
										<a href style=" text-decoration:none;color:black">{{ i }}</a>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="QRSTUVWXYZ" name="fourth">
								<div style="width:100%;">
									<div
										class="reg"
										style="float:left;width:25%;height:30px"
										v-for="(i, index) in qrstuvwxyz"
										:key="index"
										@click="passCity(i)"
									>
										<a href style=" text-decoration:none;color:black">{{ i }}</a>
									</div>
								</div>
							</el-tab-pane>
						</el-tabs>
						<el-button slot="reference">{{ this.city }}▼</el-button>
					</el-popover>
				</div>
				<div class="select-city1" @click="openClose()">
					<div>
						<p>
							{{ this.city }}
							<i class="el-icon-location"></i>
						</p>
					</div>
				</div>
				<div class="unfold" @click=";(drawer = !drawer), (check = false)">
					<i class="el-icon-s-unfold" style="font-size:20px;color:white"></i>
				</div>
				<el-input placeholder="搜索" v-model="search">
					<i class="el-icon-search" slot="suffix" style="font-size:20px;line-height:40px;cursor: pointer;" @click="queryArc()"></i>
				</el-input>
			</div>
			<div class="daohang">
				<el-menu :default-active="activeIndex1" class="el-menu-demo" mode="horizontal" text-color="#fff" active-text-color="#000">
					<el-menu-item v-for="(item, index) in column" :key="index" :index="String(index)" @click="changColumn(item, index)">{{
						item
					}}</el-menu-item>
				</el-menu>
			</div>
		</div>
		<div class="adv-column" v-if="$route.path == '/index/whole' && advColumn.src != ''" @click="advSkip(advColumn.number)">
			<img v-lazy="advColumn.src" style="cursor: pointer" />
		</div>
		<div class="bgft-box" :style="check == true ? 'top:55px' : 'top:45px'">
			<div class="nf-bg">
				<div class="nf-top">
					<div class="leftaside">
						<div class="nf-title">
							<p style="font-size:25px"><i class="el-icon-crop" style="font-size:20px;margin:0 15px 0 0"></i>专栏</p>
						</div>
						<cardsp :special="special[0]"></cardsp>
						<cardsp :special="special[1]"></cardsp>
						<div class="nf-title">
							<p style="font-size:25px"><i class="el-icon-crop" style="font-size:18px;margin:0 15px 0 0"></i>最新文章</p>
						</div>
						<div class="block">
							<el-timeline>
								<el-timeline-item v-for="(activity, index) in insNews" :key="index" :timestamp="activity.timestamp">
									<p @click="reFreshUrl(activity.number)" style="width:100%">
										<router-link
											:to="{
												path: '/index/article',
												query: { id: activity.number },
											}"
											style="text-decoration: none;color:black"
											>{{ activity.title }}</router-link
										>
									</p>
								</el-timeline-item>
							</el-timeline>
						</div>
						<div>
							<el-button style="width:300px;margin:40px 0 0 25px" @click="getMoreNews()">展开更多</el-button>
						</div>
						<div class="tu">
							<img @click="reFreshUrl(sidebar[0].number)" v-lazy="sidebar[0].src" alt />
							<div class="zi" @click="reFreshUrl(sidebar[0].number)">
								{{ sidebar[0].title }}
							</div>
						</div>
						<div class="tu">
							<img @click="reFreshUrl(sidebar[1].number)" v-if="sidebar" v-lazy="sidebar[1].src" alt />
							<div class="zi" @click="reFreshUrl(sidebar[1].number)">
								{{ sidebar[1].title }}
							</div>
						</div>
					</div>
					<router-view></router-view>
					<div class="rightaside">
						<div class="nf-title">
							<p style="font-size:25px"><i class="el-icon-crop" style="font-size:20px;margin:0 15px 0 0"></i>推荐文章</p>
						</div>
						<card :recommend="recommend[0]"></card>
						<card :recommend="recommend[1]"></card>
						<card :recommend="recommend[2]"></card>
						<card :recommend="recommend[3]"></card>
						<div>
							<el-button style="width:300px;margin:35px 0 0 0" @click="getMoreRecommend()">展开更多</el-button>
						</div>
						<div class="tu" style="margin: 50px 25px 50px 0;">
							<img @click="reFreshUrl(sidebar[2].number)" v-if="sidebar" v-lazy="sidebar[2].src" alt />
							<div class="zi" @click="reFreshUrl(sidebar[2].number)">
								{{ sidebar[2].title }}
							</div>
						</div>
						<!-- <el-alert title="该文章已下架" type="warning"></el-alert> -->
						<div class="tu" style="margin: 50px 25px 50px 0;">
							<img @click="reFreshUrl(sidebar[3].number)" v-if="sidebar" v-lazy="sidebar[3].src" alt />
							<div class="zi" @click="reFreshUrl(sidebar[3].number)">
								{{ sidebar[3].title }}
							</div>
						</div>
					</div>
				</div>
				<div
					class="bg-mid"
					v-if="this.$route.path == '/index/whole'"
					:style="this.$store.state.columnTitle == '协会' ? 'height:70px' : 'height:10px'"
				>
					<div class="eb"></div>
					<div class="xiehui" v-if="this.$route.path == '/index/whole' && this.$store.state.columnTitle == '协会'">
						<el-button @click="goxiehui()" style="width:300px">广东省房协 信息服务化平台</el-button>
						<el-button @click="goxiehui1()">广东省房协官网</el-button>
					</div>
				</div>
				<div class="bg-btm">
					<imglist></imglist>
				</div>
			</div>
			<div class="footer">
				<div>
					<p>联系我们，城市加盟</p>
				</div>
				<div>
					<p>微信：{{ topbottom.tel }} 邮箱：{{ topbottom.eMail }}</p>
				</div>
				<div style="display:flex;margin:auto;justify-content:center; ">
					<div style="cursor: pointer;" @click="beiAn()">
						<p style="font-size:10px">ICP备案编号：粤ICP备20023176号</p>
					</div>
					<div style="cursor: pointer;" @click="beiAn1()">
						<p style="font-size:10px">公安备案编号：4401042001315</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import card from "@/components/Card.vue"
import imglist from "@/components/Imglist.vue"
import cardsp from "@/components/Cardsp.vue"
var pinyin = require("../pinyin")

export default {
	components: {
		cardsp,
		card,
		imglist,
	},
	data() {
		return {
			activeIndex1: String(this.$store.state.index),
			//栏目
			column: ["全部"],
			activities: [],
			region: ["广东省"],
			flag: false,
			//当前位置
			city: this.$store.state.city,
			//检测城市
			check: false,
			//关闭手机端城市选择
			close: false,
			//栏目标题
			columnTitle: "最新文章",
			//选择城市默认出现的栏目
			activeName: "first",
			//搜索
			search: "",
			//搜索内容
			searchContent: [],
			//更多推荐文章
			moreRecommend: [],
			//抽屉
			drawer: false,
			//侧面栏
			sidebar: [
				{ title: "", src: "", number: "" },
				{ title: "", src: "", number: "" },
				{ title: "", src: "", number: "" },
				{ title: "", src: "", number: "" },
			],
			//当前窗口的宽度
			bodyWidth: document.body.clientWidth,
			//底部文字
			topbottom: {
				topBackGroundImage: "", //控制pc端顶部导航背景图片样式
				phoneTop: "", //控制移动端顶部底部背景颜色
				top2: "", //顶部图片
				tel: "", //底部电话
				eMail: "", //底部邮箱
			},
			//侧面专栏
			special: [
				{ title: "", src: "", number: "" },
				{ title: "", src: "", number: "" },
			],
			//推荐文章
			recommend: [
				{ title: "", src: "", number: "" },
				{ title: "", src: "", number: "" },
				{ title: "", src: "", number: "" },
				{ title: "", src: "", number: "" },
			],
			//限制
			limit: this.$store.state.limit,
			//检测到的城市
			checkCity: "",
			//按拼音获取城市
			abcdefgh: [],
			ijklmnop: [],
			qrstuvwxyz: [],
			//即时动态
			insNews: [],
			//广告栏一
			advColumn: { src: "", img: "" },
			aNumber: "",
		}
	},
	watch: {
		"$store.state.city": {
			handle() {
				if (this.checkCity != this.$store.state.city) {
					this.check = true
				}
			},
		},
		"$store.state.adv1": {
			handler() {
				if (this.$store.state.adv1 != "") {
					this.advColumn = this.$store.state.adv1
				}
			},
		},
		"$store.state.limit": {
			handler() {
				this.limit = this.$store.state.limit
				if (this.$store.state.addColumn == "1") {
					this.queryArc()
				}
				if (this.$store.state.addColumn == "2") {
					this.getMoreRecommend()
				}
			},
			immediate: true,
		},
	},
	methods: {
		//切换栏目
		changColumn(e, index) {
			// this.$store.state.columnTitle=e;
			this.$store.commit("setColumnTitle", e)
			this.$store.commit("setIndex", index)
			if (this.$route.path != "/index/whole") {
				this.$router.push("/index/whole")
			}
			location.reload()
			window.scrollTo(0, 0)
		},
		//关闭检测城市
		closeCheck() {
			this.check = false
		},
		//打开手机端选择城市
		openClose() {
			this.close = true
		},
		//关闭按钮
		closeIcon() {
			this.close = false
		},
		//根据ip获取城市
		async getIp() {
			const Res = await this.get("/ipAddress/getIp", {}).catch((err) => {
				console.log(err)
			})
			if (Res.code == 1) {
				if (Res.data.data.city != this.$store.state.city) {
					this.check = true
				}
				this.checkCity = Res.data.data.city
			}
			// let cityName = Res.data.msg
			// var strCity = "广东省"
			// let arr = JSON.parse(JSON.stringify(this.region))
			// arr.shift()
			// for (let i of arr) {
			// 	if (cityName.indexOf(i) != -1) {
			// 		strCity = i
			// 	}
			// }
			// if (strCity != this.$store.state.city) {
			// 	this.check = true
			// }
			// this.checkCity = strCity
		},

		//获取所有城市
		async getCity() {
			const Res = await this.post("/website/getCity", {
				city: this.city,
				code: this.bodyWidth > 768 ? 1 : 0,
			}).catch((err) => {
				console.log(err)
			})
			for (var i in Res.data.city.data) {
				this.region.push(Res.data.city.data[i].name)
			}
			this.getIp()
			var py = pinyin.getCitySort(this.region)
			//获取城市
			for (let item in py) {
				if (
					py[item].label == "A" ||
					py[item].label == "B" ||
					py[item].label == "C" ||
					py[item].label == "D" ||
					py[item].label == "E" ||
					py[item].label == "F" ||
					py[item].label == "G" ||
					py[item].label == "H"
				) {
					var arr = [...arr, ...py[item].value]
				} else if (
					py[item].label == "I" ||
					py[item].label == "J" ||
					py[item].label == "K" ||
					py[item].label == "L" ||
					py[item].label == "M" ||
					py[item].label == "N" ||
					py[item].label == "O" ||
					py[item].label == "P"
				) {
					var arr1 = [...arr1, ...py[item].value]
				} else {
					var arr2 = [...arr2, ...py[item].value]
				}
			}
			// var arr = [...this.abcdefgh, ...this.ijklmnop, ...this.qrstuvwxyz];
			arr.shift()
			this.abcdefgh = arr
			arr1.shift()
			this.ijklmnop = arr1
			arr2.shift()
			this.qrstuvwxyz = arr2
			//获取所有栏目
			for (var item in Res.data.column.data) {
				if (Res.data.column.data[item].columnName == "最新文章") {
					continue
				}
				this.column.push(Res.data.column.data[item].columnName)
			}
			//获取侧边栏
			if (Res.data.side) {
				for (var item1 in Res.data.side.data) {
					if (typeof this.sidebar[item1] == "undefined") {
						break
					}
					this.sidebar[item1].title = Res.data.side.data[item1].title
					this.sidebar[item1].src = Res.data.side.data[item1].imgUrl
					this.sidebar[item1].number = Res.data.side.data[item1].number
				}
			}
			//获得某城市的顶部底部信息
			this.topbottom.topBackGroundImage = Res.data.bottom.data.webTop1
			this.topbottom.phoneTop = Res.data.bottom.data.phoneTop
			this.topbottom.tel = Res.data.bottom.data.tel
			this.topbottom.eMail = Res.data.bottom.data.email
			//获得专栏
			if (Res.data.scolumn) {
				for (var item2 in Res.data.scolumn.data) {
					this.special[item2].title = Res.data.scolumn.data[item2].title
					this.special[item2].src = Res.data.scolumn.data[item2].imgUrl
					this.special[item2].number = Res.data.scolumn.data[item2].number
				}
			}
			//获得推荐文章
			if (Res.data.recommend) {
				for (var item3 in Res.data.recommend.data) {
					this.recommend[item3].title = Res.data.recommend.data[item3].title
					this.recommend[item3].src = Res.data.recommend.data[item3].imgUrl
					this.recommend[item3].number = Res.data.recommend.data[item3].number
				}
			}
		},
		//点击城市把city传进vuex
		passCity(e) {
			this.$store.commit("setCity", e)
			localStorage.setItem("city", e)
		},
		//自定义微信分享
		activated() {
			this.$wxShare.updateWxShareConfig({
				title: "广东房地产网",
				desc: "http://www.gdfdc.com",
				link: window.location.href,
			})
		},
		//获取最新文章
		async getNews() {
			const Res = await this.post("/website/getNews", {
				city: this.city,
				limit: "6",
			}).catch((err) => {
				console.log(err)
			})
			let tempData = []
			for (var i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					timestamp: this.handleDate(Res.data[i].createTime),
					number: Res.data[i].number,
				})
			}
			this.activities = tempData
		},
		//获取即时动态
		async getInsNews() {
			const Res = await this.post("/website/getArtByColumn", {
				city: this.city,
				aColumn: "最新文章",
				type: "1",
				limit: 6,
			}).catch((err) => {
				console.log(err)
			})
			let tempData = []
			for (var i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					subtitle: Res.data[i].subtitle,
					aColumn: Res.data[i].aColumn,
					timestamp: this.handleDate(Res.data[i].createTime),
					number: Res.data[i].number,
					src: Res.data[i].imgUrl1,
				})
			}
			this.insNews = tempData
		},
		//获取文章num
		reFreshUrl(e) {
			if (e != this.aNumber && e != null) {
				this.aNumber = e
				if (this.$route.path == "/index/article") {
					this.$store.commit("setartrcleNumber", e)
				} else {
					this.$router.push({ path: "/index/article", query: { id: e } })
				}
			} else if (e == this.aNumber && e != null) {
				this.$store.commit("setartrcleNumber", e)
			} else if (e == null) {
				this.$message({
					message: "该文章已下架",
					type: "warning",
				})
			}
		},
		//点击按钮查看更多文章
		addArticle() {
			this.$store.commit("addLimit")
		},
		//搜索文章
		async queryArc() {
			const Res = await this.post("/website/queryArc", {
				search: this.search,
				city: this.city,
				limit: this.limit,
			}).catch((err) => {
				console.log(err)
			})
			let tempData = []
			for (var i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					subtitle: Res.data[i].subtitle,
					aColumn: Res.data[i].aColumn,
					time: this.handleDate(Res.data[i].createTime),
					number: Res.data[i].number,
					src: Res.data[i].imgUrl1,
				})
			}
			this.searchContent = tempData
			if (this.$route.path != "/index/whole") {
				this.$router.push("/index/whole")
			}
			this.$store.commit("setSearchContent", this.searchContent), this.$store.commit("setAddColumn", "搜索内容"), (this.drawer = false)
		},
		//点击按钮切换城市
		chgeCity() {
			this.$store.commit("setCity", this.checkCity)
			localStorage.setItem("city", this.checkCity)
			this.check = false
			location.reload()
		},
		//点击查看更多推荐文章
		async getMoreRecommend() {
			const Res = await this.post("/website/getMoreRecommend", {
				fromCity: this.city,
				limit: this.limit,
			}).catch((err) => {
				console.log(err)
			})
			let tempData = []
			for (var i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					subtitle: Res.data[i].subtitle,
					aColumn: Res.data[i].aColumn,
					time: this.handleDate(Res.data[i].createTime),
					number: Res.data[i].number,
					src: Res.data[i].imgUrl1,
				})
			}
			if (this.$route.path != "/index/whole") {
				this.$router.push("/index/whole")
			}
			this.moreRecommend = tempData
			this.$store.commit("setmoreRecommend", this.moreRecommend), this.$store.commit("setAddColumn", "推荐文章")
		},
		//更多即时动态
		getMoreNews() {
			if (this.$route.path != "/index/whole") {
				this.$router.push("/index/whole")
			}
			this.$store.commit("setColumnTitle", "最新文章")
			window.scrollTo(0, 800)
		},
		//跳转协会
		goxiehui() {
			window.open("http://8.129.213.177/gdfx/a/login;JSESSIONID=32722cd820054a2c8d512b434ebb7da6")
		},
		goxiehui1() {
			window.open("http://second.gdfdc.com/")
		},
		//点击广告跳转
		advSkip(e) {
			if (e == null || e == "") {
				return
			} else if (e.substring(0, 2) == "WZ" || e.substring(0, 2) == "SP") {
				this.$router.push({ path: "/index/article", query: { id: e } })
			} else if (e.substring(0, 2) == "ZT") {
				this.$router.push({ path: "/special", query: { id: e } })
			} else {
				window.open(e)
			}
		},
		//跳转备案
		beiAn() {
			window.open("http://beian.miit.gov.cn/")
		},

		beiAn1() {
			window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402001161")
		},
	},
	mounted() {},
	created() {
		if (localStorage.getItem("city")) {
			this.city = localStorage.getItem("city")
			this.$store.commit("setCity", localStorage.getItem("city"))
		}
		this.getCity()
		this.activated()
		this.getInsNews()
	},
	beforeMount() {},
}
</script>

<style lang="scss" scoped>
//整体
.pub {
	width: 100%;
	height: 100%;
	margin: 0 auto;
	// position: relative;
}
//地区检测
.check-detection {
	width: 100%;
	height: 50px;
	font-size: 20px;
	text-align: center;
	padding: 10px 0 0 0;
	box-sizing: border-box;
	background-color: rgb(201, 196, 196);
}
.switch-button {
	background-color: #2a82e4;
	border: none;
	color: white;
	padding: 5px;
	margin: 0 0 6px 15px;
}
//关闭图标
.close-icon {
	float: right;
	position: relative;
	top: -35px;
	margin: 0 20px 0 0;
	i {
		font-size: 30px;
	}
}
//头部
.nav {
	background-repeat: no-repeat;
	background-size: 100% 100%;
	-moz-background-size: 100% 100%;
	border-color: #fafbfc;
}
//导航按钮
.unfold {
	display: none;
}
//搜索框
.tou {
	position: relative;
	left: 60%;
	width: 30%;
	padding-top: 35px;
	display: flex;
	/deep/.el-input {
		width: 250px !important;
	}
}
//选择城市
.select-city {
	color: #fafbfc;
	font-size: 30px;
	margin: 0 80px 20px 0;
	/deep/.el-button {
		background-color: transparent !important;
		border: none;
		color: #fff;
		font-size: 20px;
	}
	/deep/.el-button:hover {
		color: #000;
	}
}
.select-city:hover {
	color: black;
	background-color: #fafbfc;
}
.select-city1 {
	display: none;
}
/deep/.el-tabs__item {
	padding: 0 5px !important;
}
//地区
.reg {
	text-align: center;
}
//导航栏
.daohang {
	width: 100%;
	margin: auto;
}
/deep/.el-menu {
	background-color: transparent;
}
/deep/.el-menu-item {
	// display: flex;
	width: 8%;
	height: 40px !important;
	margin: 0px 1% 20px 1% !important;
	line-height: 40px;
	text-align: center;
	font-size: 16px;
}
/deep/.el-menu-item:hover {
	background: #fff !important;
	color: #000 !important;
}
/deep/.el-menu-item.is-active {
	background-color: rgb(255, 255, 255) !important;
}
//顶部广告栏
.adv-column {
	width: 85%;
	height: 200px;
	margin: auto;
	padding: 20px;
	box-sizing: border-box;
	img {
		width: 100%;
		height: 100%;
	}
}
//中间主体
.nf-bg {
	width: 1400px;
	margin: auto;
	background-color: #f7f7f7;
}
.nf-top {
	display: flex;
	// justify-content:space-between;
}
//左aside
.leftaside {
	height: 100%;
	background-color: #f7f7f7;
	border: none;
	margin: 0 30px 0 0;
}
// /deep/.el-row{
//   padding: 0 20px 50px 20px;
// }

//右aside
.rightaside {
	border: none;
	margin: 0 0 0 30px;
}
.nf-title {
	height: 40px;
	padding: 30px 0 18px 30px;
}
.block {
	margin: 0 0 50px 30px;
	padding: 0 30px 0 0;
	width: 300px;
	box-sizing: border-box;
}
.bgft-box {
	background-color: #f7f7f7;
}
/deep/.el-timeline {
	height: 420px;
}
/deep/.el-timeline-item {
	font-size: 16px;
}
.tu {
	width: 300px;
	height: 250px;
	cursor: pointer;
	margin: 50px 0 50px 25px;
	img {
		width: 100%;
		height: 100%;
	}
}
.zi {
	width: 300px;
	height: 62px;
	position: relative;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	top: -66px;
	background-color: rgba(0, 0, 0, 0.4);
	font-size: 20px;
	color: #fff;
	box-sizing: border-box;
	padding: 6px 15px 15px 15px;
}
.bg-mid {
	// float: left;
	width: 100%;
	height: 10px;
	background-color: #f7f7f7;
	/deep/.el-button {
		display: block;
		width: 250px;
		margin: 0 auto;
		border: #000 solid 1px;
	}
}
.xiehui {
	position: relative;
	width: 30%;
	left: 55%;
	margin-top: 20px;
	/deep/.el-button {
		display: block;
		width: 150px;
		margin: 0 auto 30px auto;
		border: #000 solid 1px;
	}
}
.bg-btm {
	margin: 50px 0 0 0;
	width: 100%;
	background-color: #f7f7f7;
}
.footer {
	box-sizing: border-box;
	margin-top: 0px;
	height: 210px;
	color: #fff;
	background-image: url("../assets/footer1.jpg");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	-moz-background-size: 100% 100%;
	// -moz-background-size: 100% 100%;
	z-index: 9999;
	clear: both;
	p {
		position: relative;
		top: 20px;
		margin: 10px;
		text-align: center;
	}
}
@media (max-width: 1400px) {
	.daohang {
		width: 100%;
	}
	.adv-column {
		width: 100%;
	}
	.nf-bg {
		width: 100%;
	}
}
@media (max-width: 768px) {
	.choose-city {
		position: fixed;
		z-index: 9999;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(230, 230, 230, 0.97);
	}
	.adv-column {
		display: none;
	}
	.icon-close {
		position: absolute;
		top: 4%;
		left: 85%;
		font-size: 30px;
	}
	.choose-city-content {
		padding-top: 10px;
		margin-top: 10px;
	}
	.choose-city-content1 {
		margin-left: auto;
		margin-right: auto;
	}
	.choose-city-boxs {
		margin: 0 20px 0 20px;
		box-sizing: border-box;
	}
	.choose-city-txt1 {
		font-size: 14px;
		color: #999;
		line-height: 40px;
		height: 40px;
		vertical-align: middle;
		margin: 0px;
	}
	.choose-city-box {
		display: block;
	}
	.showcity {
		width: 30.33%;
		background-color: #fff;
		line-height: 38px;
		font-size: 14px;
		margin-left: 3%;
		margin-top: 15px;
		text-align: center;
		box-sizing: border-box;
		a {
			text-decoration: none;
			color: #666;
		}
	}
	.showcity1 {
		width: 30.33%;
		float: left;
		background-color: #fff;
		line-height: 38px;
		font-size: 14px;
		margin-left: 3%;
		margin-top: 15px;
		text-align: center;
		box-sizing: border-box;
		a {
			text-decoration: none;
			color: #666;
		}
	}
	/deep/.el-collapse-item__header {
		background-color: transparent;
	}
	.nav-box {
		position: fixed;
		z-index: 999;
		width: 100%;
		top: 0px;
	}
	.nav {
		background-image: none;
		height: 50px;
		width: 100%;
	}
	.check-detection {
		width: 100%;
		height: 25px;
		text-align: center;
		vertical-align: middle;
		padding: 4px 0 0 0;
		box-sizing: border-box;
		background-color: rgb(145, 140, 140);
		p {
			font-size: 12px;
		}
	}
	.bgft-box {
		width: 100%;
		background-color: #efefef;
	}
	.switch-button {
		font-size: 5px;
		margin: 0 0 7px 0;
		position: relative;
		top: -2px;
	}
	.close-icon {
		top: -30px;
		margin: 0 10px 0 0;
		i {
			font-size: 20px;
		}
	}
	//弹出导航
	/deep/.el-drawer {
		background-color: transparent;
		color: white;
		/deep/.el-input__inner {
			width: 130% !important;
		}
		ul {
			margin: 0 0 0 20px;
			li {
				list-style-type: none;
				margin: 0 0 20px 0;
				a {
					text-decoration: none;
					color: white;
				}
			}
		}
	}
	/deep/.el-drawer {
		width: 100% !important;
	}
	/deep/.el-drawer__body {
		overflow: auto;
	}
	/deep/.el-drawer__wrapper {
		top: 50px;
	}
	.daohang {
		display: none;
	}
	.select-city {
		display: none;
	}
	.select-city1 {
		color: #fff;
		display: flex;
	}
	.unfold {
		display: block;
		float: right;
		margin: 2px 0 0 20px;
	}
	.tou {
		padding-top: 15px;
		left: 70%;
		width: 30%;
		display: flex;
		/deep/.el-input {
			display: none;
		}
	}
	.leftaside {
		display: none;
	}
	.rightaside {
		display: none;
	}
	.bg-mid {
		display: none;
	}
	.footer {
		background-image: url("../assets/footer5.png");
		height: 100px;
		p {
			position: relative;
			top: 5px;
			margin: 5px;
			text-align: center;
			font-size: 12px;
		}
	}
}
</style>
